import { MutationCache, QueryClient } from '@tanstack/react-query';
import { isApiClientError } from './api';
import { showErrorToast } from './toast';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      /** Set when the screen renders the error itself (inline field errors, cell state). */
      readonly silentError?: boolean;
    };
  }
}

/** Client errors (4xx) are final; retry server/network failures once. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiClientError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.silentError) return;
        showErrorToast(error instanceof Error ? error.message : 'Что-то пошло не так');
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: shouldRetry,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createQueryClient();
